import React from "react"
import { Dialog, DialogContent, DialogTitle } from "@mui/material"

const GlobalDialog = ({
  open,
  onClose,
  titleContent,
  bodyContent,
  customStyles,
  disableEscapeKeyDown,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="md"
    sx={{
      textAlign: "center",
      background: customStyles?.background || "rgba(122, 122, 122, 0.5)",
      backdropFilter: customStyles?.backdropFilter || "blur(1.5px)",
      borderRadius: customStyles?.borderRadius || "10px",
      ...customStyles?.dialogStyles
    }}
    disableEscapeKeyDown={disableEscapeKeyDown}
  >
    <DialogTitle
      sx={{
        display: "flex",
        justifyContent: customStyles?.justifyTitleContent || "flex-start",
        padding: customStyles?.titlePadding || "10px",
        color: customStyles?.titleColor || "#0C82EA",
        ...customStyles?.titleStyles
      }}
    >
      {titleContent}
    </DialogTitle>
    <DialogContent>{bodyContent}</DialogContent>
  </Dialog>
)

export default GlobalDialog
